import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 36"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M32.625 18A14.625 14.625 0 1 0 18 32.625 14.625 14.625 0 0 0 32.625 18M0 18a18 18 0 1 1 18 18A18 18 0 0 1 0 18m13.24-7.657a1.69 1.69 0 0 1 1.709.035l10.125 6.187a1.69 1.69 0 0 1 0 2.883l-10.126 6.188a1.7 1.7 0 0 1-1.709.035 1.68 1.68 0 0 1-.865-1.47V11.813a1.68 1.68 0 0 1 .866-1.47",
  "data-name": "Icon fa-regular-circle-play"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "play"}) } }